import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Subtract"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4936 15.1652C17.7482 13.6183 18.5 11.6469 18.5 9.5C18.5 4.52944 14.4706 0.5 9.5 0.5C7.35305 0.5 5.38168 1.25176 3.83477 2.5064L16.4936 15.1652ZM15.0698 16.5699C13.5377 17.7787 11.6031 18.5 9.5 18.5C4.52944 18.5 0.5 14.4706 0.5 9.5C0.5 7.39693 1.22134 5.46235 2.4301 3.93015L15.0698 16.5699Z"
      fill="#222A5C"
    />
  </svg>,
  "OptOutFilled"
);
